import { memo } from "react";

// Natural seed color palette — inspired by real Tsoro/mancala seeds (bean, pebble, polished stone)
// Each color is an HSL triplet that maps into --seed-color.
const SEED_COLORS = [
  "32 70% 60%",   // amber bean
  "28 55% 48%",   // toasted bean
  "20 45% 38%",   // mahogany
  "40 35% 75%",   // cream stone
  "45 25% 60%",   // sand pebble
  "15 50% 42%",   // brick red
  "55 30% 55%",   // mossy olive
  "30 65% 50%",   // burnt ochre
];

const MAX_SEEDS = 7;

function deterministicColor(row, col, i) {
  // Deterministic so the seed colors stay stable across re-renders / animations.
  const h = (row * 31 + col * 17 + i * 7) % SEED_COLORS.length;
  return SEED_COLORS[h];
}

// Slightly organic but deterministic position layout (percent inside the pit).
const LAYOUTS = [
  [],
  [[50, 50]],
  [[36, 50], [64, 50]],
  [[50, 36], [36, 60], [64, 60]],
  [[36, 36], [64, 36], [36, 64], [64, 64]],
  [[50, 30], [30, 50], [70, 50], [38, 70], [62, 70]],
  [[34, 32], [66, 32], [34, 56], [66, 56], [50, 72], [50, 38]],
  [[34, 30], [66, 30], [50, 46], [30, 60], [70, 60], [40, 74], [60, 74]],
];

export const Seeds = memo(function Seeds({ count, row = 0, col = 0 }) {
  if (!count) return null;
  const capped = Math.min(count, MAX_SEEDS);
  const positions = LAYOUTS[capped] || LAYOUTS[MAX_SEEDS];
  return (
    <svg
      viewBox="0 0 100 100"
      className="absolute inset-0 w-full h-full pointer-events-none"
      aria-hidden="true"
    >
      {positions.map(([cx, cy], i) => {
        const color = deterministicColor(row, col, i);
        // Pseudo-random rotation derived from indices for organic feel.
        const rot = ((row * 53 + col * 11 + i * 29) % 180) - 90;
        return (
          <g key={i} transform={`rotate(${rot} ${cx} ${cy})`}>
            <ellipse
              cx={cx}
              cy={cy}
              rx="11"
              ry="8"
              className="seed-token"
              style={{ "--seed-color": color }}
            />
          </g>
        );
      })}
    </svg>
  );
});
